<template>
  <div
    class="layout__component-container-wrap layout__component-container-wrap--light"
  >
    <div class="layout__component-container layout--flex-start">
      <div class="dashboard__header-info">
        <!-- hello section -->
        <div class="dashboard__header-section">
          <div class="dashboard__header-info-panel">
            <h2
              class="text-size-xl layout--margin-bottom-xs layout--margin-top-xs layout--ellipses weight--black"
            >
              Hello, {{ user.firstName }}!
            </h2>
            <p>
              You are currently on the {{ subscription.discriminator }} Plan.
              {{ " &nbsp;" }}
              <a
                href="https://motionmail.freshdesk.com/support/solutions/articles/14000073821-how-do-i-create-a-motionmail-timer"
                class="link"
                target="_blank"
                >How to create timers</a
              >
            </p>
            <p v-if="!isAccountActive">
              Account Status: {{ accountStatus }}
            </p>
          </div>
          <!-- create a timer button -->
          <div class="dashboard__header-button-panel">
            <component
              :is="isAccountActive ? 'router-link' : 'button'"
              :to="{ name: 'create a timer' }"
              :disabled="!isAccountActive"
              class="button button--big layout--block layout--margin-top-md layout--flex-align-center layout--flex-center"
            >
              <IconCreateTimer
                class="layout--margin-right-xxs"
                style="width: 26px; height: 26px;"
              />
              Create a timer
            </component>
          </div>
        </div>
        <Divider dark class="layout--margin-top-md layout--margin-bottom-md" />
        <!-- available credits section loads when subscription options are loaded -->
        <v-wait for="loading subscription options">
          <spring-spinner
            :animation-duration="1500"
            :size="53"
            :color="'#b6bbff'"
            transition="fade"
            mode="out-in"
            :duration="1000"
            enter-active-class="enter-active"
            slot="waiting"
          />
          <div class="dashboard__header-section">
            <div class="dashboard__header-info-panel">
              <AvailableCredits />
            </div>
            <!-- low / no / negative credit messages -->
            <div class="dashboard__header-button-panel">
              <CreditMessage />
            </div>
          </div>
        </v-wait>
      </div>
      <!-- feature section -->
      <!-- <div class="dashboard__header-feature">
        <Feature />
      </div> -->
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { mapWaitingActions } from "vue-wait";

import Divider from "../../../components/Divider";
import AvailableCredits from "./header/AvailableCredits";
import CreditMessage from "./header/CreditMessage";
import Feature from "./header/Feature";
import IconCreateTimer from "../../../assets/icons/iconCreateTimer-Plus.svg";

export default {
  name: "dashboard-overview-header",
  // load subscription options into vuex if not already loaded
  mounted: function() {
    if (this.subscriptionOptions.length === 0) {
      this.getSubscriptionOptions();
    }
  },
  components: {
    Divider,
    AvailableCredits,
    CreditMessage,
    Feature,
    IconCreateTimer,
  },
  computed: {
    ...mapGetters("account", [
      "user",
      "subscription",
      "subscriptionOptions",
      "account",
      "accountStatus",
      "isAccountActive",
    ]),
  },
  methods: {
    ...mapWaitingActions("account", {
      getSubscriptionOptions: "loading subscription options",
    }),
  },
};
</script>

<style></style>
